// extracted by mini-css-extract-plugin
export var discard = "_5y-3";
export var muiTooltipTooltip = "_5y-5";
export var notificationBar = "_5y-2";
export var saveButtonHoverSlotWrapper = "_5y-4";
export var show = "_5y-1";
export var spacer = "_5y-0";